import React, { useMemo } from "react";

import VStack from "../../../ui_atoms/VStack";
import PayrollBreakdownTotalInfo from "./PayrollBreakdownTotalInfo";
import Gap from "../../../ui_atoms/Gap";
import PayrollBreakdownMonthlyInfo from "./PayrollBreakdownMonthlyInfo";
import PayrollBreakdownAbsences from "./PayrollBreakdownAbsenses";
import { PayrollBreakdownViewerProps } from "./PayrollBreakdownDetails";
import {
    PayrollBreakdownStatus,
    PayrollSourceType,
    TimeSheetState,
} from "../../../__generated__/graphql";

const PayrollBreakdownMonthly: React.FC<PayrollBreakdownViewerProps> = ({
    payrollBreakdown,
    vacationStatus,
}) => {
    const allCompleted =
        payrollBreakdown?.timesheets?.length &&
        payrollBreakdown?.timesheets?.every(
            (ts) => ts.status === TimeSheetState.Submitted || ts.status === TimeSheetState.Accepted,
        );

    const displayInfo = useMemo(() => {
        return (
            // a paid décompte has been submitted before
            payrollBreakdown.status !== PayrollBreakdownStatus.Open ||
            (payrollBreakdown.missionInfo.payrollSource === PayrollSourceType.Lift && allCompleted)
        );
    }, [allCompleted, payrollBreakdown]);

    return (
        <VStack>
            <VStack h="2/3">
                <PayrollBreakdownMonthlyInfo
                    payrollBreakdown={payrollBreakdown}
                    disabled={!displayInfo}
                />
                <Gap gap={0.25} />
                <PayrollBreakdownTotalInfo
                    payrollBreakdown={payrollBreakdown}
                    vacationStatus={vacationStatus}
                    disabled={!displayInfo}
                />
            </VStack>
            <PayrollBreakdownAbsences absences={payrollBreakdown.absences} />
        </VStack>
    );
};

export default PayrollBreakdownMonthly;
